import { Component } from 'react';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import Button from '../ui/Button';

/**
 * ErrorBoundary debe ser class component — no hay equivalente con hooks.
 * Captura errores de render; no captura errores async ni event handlers.
 * Para esos casos usamos try/catch + ToastContext.
 */
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // En producción esto va a Sentry / Crashlytics
    console.error('[ErrorBoundary] Captured:', error, errorInfo);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex min-h-[100dvh] flex-col items-center justify-center gap-4 bg-slate-50 px-6 text-center">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
          <AlertTriangle className="h-8 w-8 text-status-red" aria-hidden="true" />
        </div>
        <h1 className="text-xl font-semibold text-slate-900">Algo salió mal</h1>
        <p className="max-w-sm text-sm text-slate-600">
          La aplicación encontró un error inesperado. Podés reintentar o recargar la página.
        </p>
        {import.meta.env.DEV && this.state.error && (
          <pre className="mt-2 max-w-md overflow-auto rounded-lg bg-slate-900 p-3 text-left text-xs text-slate-100">
            {this.state.error.toString()}
          </pre>
        )}
        <div className="mt-2 flex gap-2">
          <Button variant="secondary" onClick={this.handleReset}>
            Reintentar
          </Button>
          <Button variant="primary" leftIcon={RefreshCw} onClick={this.handleReload}>
            Recargar
          </Button>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;